<template>
    <div class="WarehouseStocking">
      <!--  入仓单 -->
      <div
        style="justify-content: space-between; align-items: center"
        v-if="type === 'true'"
      >
        <!-- <van-button
          type="info"
          size="small"
          style="display: flex"
          :text="ray"
          @click="holdRay()"
        ></van-button> -->
        <div>
          <input
            id="scanQRCode"
            ref="getIDInpot"
            @keyup.enter="add_jh()"
            v-model="add_data"
            readonly
            style="height: 28px; width: 180px ; margin-top: 10%; "
            autocomplete="off"
            placeholder="扫描对应卷号条码（手输）"
          />
        </div>
      </div>
  
      <div :style="style" v-if="flag_x">
            <div class="data-top">
              <div class="right-twenty">货号</div>
              <div class="right-twenty">现存量</div>
              <div class="right-twenty">卷号</div>
              <div class="right-twenty">货位</div>
              <div class="right-twenty">仓库</div>
            </div>
            <div class="data-top">
              <div class="data-order">{{ w_data.number }}</div>
              <div class="data-order">{{ w_data.store }}</div> <!--现存量-->
              <div class="data-order">{{ w_data.reel }}</div> <!--卷号-->
              <div class="data-order">{{ w_data.goods }}</div> <!--货位-->
              <!--<div class="data-order" v-if="w_data.goods !==''" >仓内</div> 
              <div class="data-order" v-else style="color: red;">仓外</div> -->
              <div class="data-order">{{ w_data.warehouse }}</div> <!--仓库-->
            </div>
            <div class="data-top">
              <van-button type="info" round class="bottom-button-x" @click="go_in()">入仓</van-button>
              <van-button type="info" round class="bottom-button-x" @click="go_out()">出仓</van-button>
              <van-button type="warning" round class="bottom-button-x" @click="go_xout()">消仓</van-button>
              <van-button type="warning" round class="bottom-button-x" @click="go_fout()">返仓</van-button>
            </div>
      </div>
  
      <div class="filling-goods-bottom">
        <van-button type="warning" class="bottom-button"  @click="go_index()">
          回首页
        </van-button>
        <!-- <van-button
          type="info"
          v-if="type === 'true'"
          @click="warehous"
          class="bottom-button"
        >
          确认入库
        </van-button>
        <van-button type="warning" @click="reload()">新建</van-button>-->
        <van-button type="info" class="bottom-button" v-if="out_success" @click="toOrderInfo()">领料出库</van-button>
      </div>
    </div>
  </template>
  
  <script>
  import { Dialog } from "vant";
  import { Toast } from "vant";
  import { get, post } from "@/utils/request";
  import { config } from "process";
  export default {
    name: "WarehouseStocking",
    data() {
      return {
        ray: "已暂停，点击我继续扫码",
        add_data: "",
        all_data: [],
        w_data: '',
        mxm: "",
        style: "",
        type: "true",
        ware_type: 0,
        belong: "",
        flag_x:false,
        out_success:false,
      };
    },
    mounted() {
      var h = document.documentElement.clientHeight || document.body.clientHeight;
      this.style =
        "text-align: left;width: 100%;height: " + h * 0.78 + "px;overflow:scroll";
  
      this.holdRay();
    },
    methods: {
      toOrderInfo() {
        this.$router.push({
          path: "/orderInfo",
        });
      },
      go_index() {
        //回到首页
        Dialog.confirm({
          message: "确定要回首页吗？",
        })
          .then(() => {
            this.$router.push("/home");
          })
          .catch(() => {
            // on cancel
          });
      },
      reload() {
        window.location.reload();
      },
      holdRay() {
        this.ray = "扫描中";
        if (this.add_data) {
          // 如果箱号的框有值
          this.$refs.getIDInpot2.focus();
          this.$refs.getIDInpot.setAttribute("readonly", "readonly");
          this.$refs.getIDInpot2.removeAttribute("readonly");
        } else {
          this.focus();
        }
      },
      focus() {
        this.$refs.getIDInpot.focus();
        this.$refs.getIDInpot.setAttribute("readonly", "readonly");
        setTimeout(() => {
          this.$refs.getIDInpot.removeAttribute("readonly");
        }, 200);
      },
      hideMessage() {
        this.ray = "已暂停，点击我继续扫码";
      },
      async add_jh() {
        let flag = true;
        if (!navigator.onLine) {
          Toast("当前网络故障");
          this.add_data = "";
          return;
        }
        await get(this.APIOBJ.WarehouseInScanReel,{
          reel: this.add_data,
        }).then((res) => {
          if (res.data.status == "1") {
            // 如果是1  就说明成功
            this.w_data = res.data.data; // 获取货位
            Toast(res.data.msg);
            this.flag_x=true;
          } else {
            flag = false;
            Toast(res.data.msg);
          }
        });
        if (flag) {
          this.$refs.getIDInpot.focus();
          this.$refs.getIDInpot.setAttribute("readonly", "readonly");
          this.$refs.getIDInpot.removeAttribute("readonly");
        }
      },
      go_in(){  //入仓
        if (!navigator.onLine) {
          Toast("当前网络故障");
          this.add_data = "";
          return;
        }
        this.get(this.APIOBJ.WarehouseStocking,{
          timeout: 10000,
          reel: this.add_data,
        }).then((res) => {
          if (res.data.status == "1") {
            // 如果是1  就说明成功
            //this.add_data = res.data.data.goods_num; // 获取货位
            Toast(res.data.msg);
            this.flag_x=false;
          } else {
            Toast(res.data.msg);
          }
        });
      },
      go_out(){  //出仓
        if (!navigator.onLine) {
          Toast("当前网络故障");
          this.add_data = "";
          return; 
        }
        this.get(this.APIOBJ.WarehouseOutbound,{
          timeout: 10000,
          reel: this.add_data,
        }).then((res) => {
          if (res.data.status == "1") {
            // 如果是1  就说明成功
            //this.add_data = res.data.data.goods_num; 
            Toast(res.data.msg);
            this.flag_x=false;
            this.out_success=true;
          } else {
            Toast(res.data.msg);
          }
        });
      },
      go_xout(){  //销仓 
        if (!navigator.onLine) {
          Toast("当前网络故障");
          this.add_data = "";
          return;
        }
        this.get(this.APIOBJ.WarehouseStockingCancel,{
          timeout: 10000,
          reel: this.add_data,
        }).then((res) => {
          if (res.data.status == "1") {
            // 如果是1  就说明成功
            //this.add_data = res.data.data.goods_num; 
            Toast(res.data.msg);
            this.flag_x=false;
          } else {
            Toast(res.data.msg);
          }
        });
      },
      go_fout(){  //返仓 
        if (!navigator.onLine) {
          Toast("当前网络故障");
          this.add_data = "";
          return;
        }
        this.get(this.APIOBJ.WarehouseOutboundCancel,{
          timeout: 10000,
          reel: this.add_data,
        }).then((res) => {
          if (res.data.status == "1") {
            // 如果是1  就说明成功
            //this.add_data = res.data.data.goods_num; 
            Toast(res.data.msg);
            this.flag_x=false;
          } else {
            Toast(res.data.msg);
          }
        });
      },
    },
  };
  </script>
  
  <style>
  .filling-goods-bottom {
    display: flex;
    position: absolute;
    bottom: 0;
    width: 100%;
    margin-left: -10px;
  }
  .goods-info-two {
    margin-top: 10px;
    background-color: #f2f2f2;
    padding-bottom: 10px;
  }
  .info-order-h {
    width: 100%;
    display: flex;
    padding-top: 5px;
  }
  .order-info-input {
    border-radius: 5px;
    border: 1px solid #444444;
    text-align: center;
    width: 4.5rem;
  }
  .info-order-data {
    width: 65%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .info-order-title {
    width: 35%;
  }
  .data-top{
    width: 100%; 
    display: flex; 
    align-items: center;
    flex-wrap: nowrap;
    justify-content: space-evenly;
    margin-top: 5%;
  }
  .right-twenty{
    /*padding-left: 5%;*/
    width: 18%;
    text-align: center;
  }
  .data-order{
    width: 18%;
    text-align: center;
    word-wrap: break-word;
  }
  .bottom-button-x{
    border-radius: 0.5em;
    width: 22%;
  }
  </style>